/**
 * List of EU country codes
 * European Union member states
 */
export const EU_COUNTRIES = [
  "AT", // Austria
  "BE", // Belgium
  "BG", // Bulgaria
  "HR", // Croatia
  "CY", // Cyprus
  "CZ", // Czech Republic
  "DK", // Denmark
  "EE", // Estonia
  "FI", // Finland
  "FR", // France
  "DE", // Germany
  "GR", // Greece
  "HU", // Hungary
  "IE", // Ireland
  "IT", // Italy
  "LV", // Latvia
  "LT", // Lithuania
  "LU", // Luxembourg
  "MT", // Malta
  "NL", // Netherlands
  "PL", // Poland
  "PT", // Portugal
  "RO", // Romania
  "SK", // Slovakia
  "SI", // Slovenia
  "ES", // Spain
  "SE", // Sweden
] as const;

/**
 * Check if a country code is an EU member state
 * @param countryCode - Two-letter country code (e.g., "LT", "DE")
 * @returns true if the country is an EU member state
 */
export const isEuCountry = (countryCode?: string): boolean => {
  if (!countryCode) return false;
  return EU_COUNTRIES.includes(countryCode.toUpperCase() as any);
};
